import api from '@/lib/api';

export interface CreateRulePayload {
  unitId: string;
  ruleType: string;
  conditionOperator?: string | null;
  conditionValue?: number | null;
  adjustmentType: string;
  adjustmentValue: number;
  priority: number;
  validFrom?: string | null;
  validTo?: string | null;
}

export interface UpdateRulePayload extends Partial<CreateRulePayload> {}

export interface OverridePricePayload {
  unitId: string;
  newPrice: number;
  reason: string;
}

export interface AuditLogQuery {
  unitId?: string;
  page?: number;
  limit?: number;
}

export async function fetchPricingRules(unitId?: string) {
  const { data } = await api.get('/pricing/rules', {
    params: unitId ? { unitId } : undefined,
  });
  return data;
}

export async function createRule(payload: CreateRulePayload) {
  const { data } = await api.post('/pricing/rules', payload);
  return data;
}

export async function updateRule(id: string, payload: UpdateRulePayload) {
  const { data } = await api.patch(`/pricing/rules/${id}`, payload);
  return data;
}

export async function deleteRule(id: string) {
  await api.delete(`/pricing/rules/${id}`);
}

export async function overridePrice(payload: OverridePricePayload) {
  const { data } = await api.post('/pricing/override', payload);
  return data;
}

export async function fetchAuditLog(query?: AuditLogQuery) {
  const { data } = await api.get('/pricing/audit', { params: query });
  return data;
}
